import { Box, Grid, Skeleton, SxProps } from "@mui/material";
import { FC } from "react";

const style: SxProps = {
  padding: 1,
  mx: 2,
};

const PPSkeleton: FC<{}> = () => {
  return (
    <Box sx={{ ...style }}>
      <Grid
        container
        spacing={{ xs: 1, sm: 1, md: 1, lg: 2, xl: 2 }}
        columns={{ xs: 2, sm: 4, md: 8, lg: 8, xl: 16 }}
        justifyContent="center"
      >
        <Grid item xs={2} sm={4} md={8} lg={16} xl={16} justifyContent="center">
          <Skeleton animation="pulse" height="5rem" />
        </Grid>
      </Grid>
    </Box>
  );
};

export default PPSkeleton;
//PPSkeleton.whyDidYouRender = true;
